import { useCallback, useState } from 'react';
import { Columns, Element } from 'react-bulma-components';
import { FaTrash } from 'react-icons/fa6';
import Button from '../../ui/button/button';
import Modal from '../../ui/modal/modal';

export type SoftwareUnassignmentConfirmationModalProps = {
  show: boolean;
  licenseKey: string;
  onCancel: () => void;
  onUnassign: () => Promise<void>;
};

export function SoftwareUnassignmentConfirmationModal({
  show,
  licenseKey,
  onCancel,
  onUnassign,
}: SoftwareUnassignmentConfirmationModalProps) {
  const [loading, setLoading] = useState(false);

  const handleOnUnassign = useCallback(async () => {
    setLoading(true);
    await onUnassign();
    setLoading(false);
  }, [onUnassign]);

  return (
    <Modal show={show} title="Unassign software from device">
      <Element renderAs="p" my={4}>
        Are you sure you want to unassign license key
        <span className="has-text-weight-bold"> {licenseKey} </span>
        from this device?
      </Element>
      <Columns mt={4}>
        <Columns.Column>
          <Button color="primary-dark" outlined onClick={onCancel}>
            No, cancel
          </Button>
        </Columns.Column>
        <Columns.Column display="flex" justifyContent="flex-end">
          <Button
            color="danger-dark"
            isExecutingAction={loading}
            onClick={handleOnUnassign}
          >
            <Button.LoadingIcon icon={FaTrash} />
            <span>Yes, unassign</span>
          </Button>
        </Columns.Column>
      </Columns>
    </Modal>
  );
}
